/**
 * Localization strings for the Lift Programmer game (English)
 */
export const strings = {
    // App
    appTitle: 'Lift Programmer',

    // UI Chrome
    generation: 'Generation',
    stop: 'Stop',
    run: 'Run',
    pause: 'Pause',
    resume: 'Resume',
    stepBack: 'Step Back',
    endMission: 'End Mission',
    endMissionConfirm: 'Are you sure you want to end this mission?',

    // Mission Settings
    missionSettings: 'Mission Settings',
    numberOfFloors: 'Number of Floors',
    numberOfLifts: 'Number of Lifts',
    startMission: 'Start Mission',

    // Floor Button Types
    buttonTypeSingleCall: 'Single Call',
    buttonTypeUpDown: 'Up/Down',
    buttonTypeNumberedFloors: 'Numbered Floors',

    // Lift Settings
    weightLimit: 'Weight Limit',
    startingFloor: 'Starting Floor',
    bottomFloor: 'Bottom Floor',
    topFloor: 'Top Floor',
    liftMoveSpeedSeconds: 'Seconds per floor move',

    // Code Editor
    documentation: 'Documentation',
    console: 'Console',
    main: 'main',
    clear: 'Clear',
    save: 'Save',
    saveToLibrary: 'Save to Library',
    loadFromLibrary: 'Load from Library',
    newTab: 'New Tab',
    deleteTab: 'Delete Tab',
    deleteTabConfirm: 'Are you sure you want to delete this tab?',

    // Console
    consoleLines: 'lines',
    enterCommand: 'Enter command...',

    // Simulation
    simulationEnd: 'Simulation End',
    simulationPaused: 'Simulation Paused',

    // Lift
    floor: 'Floor',
    lobby: 'Lobby',
    targetFloor: 'Target',
    doorOpen: 'Door Open',
    doorClosed: 'Door Closed',
    liftFull: 'Lift Full',

    // Errors
    errorLiftInMotion: 'Cannot open/close door while lift is in motion',
    errorInvalidFloor: 'Invalid floor number',

    // Libraries
    libraries: 'Libraries',
    libraryName: 'Library Name',
    createNew: 'Create New',
    overwrite: 'Overwrite',
    cancel: 'Cancel',
    confirm: 'Confirm',
    empty: 'Empty',

    // Editor Management
    editorSave: 'Save',
    editorLoad: 'Load',
    editorReset: 'Reset',
    editorSaveTooltip: 'Save code to local storage',
    editorLoadTooltip: 'Load code from local storage',
    editorResetTooltip: 'Reset to template code',
    editorSaveSuccess: 'Code saved successfully!',
    editorLoadConfirm: 'Are you sure you want to load the saved code? This will overwrite your current progress in the editor.',
    editorResetConfirm: 'Are you sure you want to reset the editor to the template code? This will overwrite your current progress.',

    // Tabs
    tabDocumentation: 'Documentation',
    tabCode: 'Code',
    tabSnippets: 'Snippets',
    tabConsole: 'Console',
    copy: 'Copy',
    copied: 'Copied!',
} as const;

export type StringKey = keyof typeof strings;

/**
 * Get a localized string by key
 */
export function t(key: StringKey): string {
    return strings[key];
}
